/**
 * Antecedents Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    antecedents: [],
    antecedent: {}
};

// Getters
const getters = {
    antecedents: state => {
        return state.antecedents
    },

    antecedent: state => {
        return state.antecedent
    }
};

// Actions
const actions = {
    getAntecedents(context, payload) {
        function successCallback(response) {
            context.commit('getAntecedentsHandler', { antecedents: response.data.antecedents });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Antecedent.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getAntecedent(context, payload) {
        function successCallback(response) {
            context.commit('getAntecedentHandler', { antecedent: response.data.antecedent });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Antecedent.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createAntecedent(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            context.commit('setAntecedentHandler', { antecedents: response.data.dossier.antecedents });


            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({name: 'add-antecedent', params: { file: response.data.antecedent.dossier.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Antecedent.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateAntecedent(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'antecedent' });
            router.push({ name: 'antecedent', params: { antecedent: response.data.antecedent.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Antecedent.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteAntecedent(context, payload) {
        function successCallback(response) {
            // context.commit('deleteAntecedentHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Antecedent.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getAntecedentsHandler(state, { antecedents }) {
        // Update antecedents state
        state.antecedents = antecedents;
    },

    getAntecedentHandler(state, { antecedent }) {
        // Update antecedent state
        state.antecedent = antecedent;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}